<template>
  <div>
    <div class="button-g">
      <div class="btn-square" @click="show('data')" :class="{ 'active': data }">データ</div>
      <div class="btn-square" @click="show('student')" :class="{ 'active': student }">生徒</div>
      <div class="btn-square" @click="show('history')" :class="{ 'active': history }">対応履歴</div>
      <div class="btn-square" @click="show('medium')" :class="{ 'active': medium }">媒体</div>
      <div class="btn-square" @click="show('map')" :class="{ 'active': map }">地図</div>
      <div class="btn-square" @click="show('file')" :class="{ 'active': file }">ファイル</div>
      <div class="btn-square"><tutor-modal :tutor="tutor"></tutor-modal></div>
    </div>

    <div class="flex tutor2">
      <template v-if="data">
        <div class="basic">
          <tutor-profile2 :tutor="tutor" :edit_id="edit_id"></tutor-profile2>
        </div>
      </template>
      <template v-if="student">
        <div class="basic">
          <tutor-student2 :tutor="tutor"></tutor-student2>
        </div>
      </template>
      <template v-if="history">
        <div class="basic">
          <tutor-history2 :tutor="tutor" :condition="condition" :edit_id="edit_id" type="true"></tutor-history2>
        </div>
      </template>
      <template v-if="medium">
        <div class="basic">
          <tutor-medium2 :tutor="tutor" :edit_id="edit_id" type="true"></tutor-medium2>
        </div>
      </template>
      <template v-if="map">
        <div class="basic">
          <tutor-map2 :tutor="tutor" :edit_id="edit_id" type="true"></tutor-map2>
        </div>
      </template>
      <template v-if="file">
        <div class="basic">
          <tutor-file2 :tutor="tutor" :edit_id="edit_id" type="true"></tutor-file2>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tutor: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
      data: true,
      student: true,
      history: false,
      map: false,
      medium: false,
      file: false
    }
  },
  methods: {
    show (col) {
      this[col] = !this[col]
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.tutor_id === this.tutor.id) {
      alert('先生情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.tutor_channel_id) {
      alert('登録媒体が編集中です')
      return
    }
    next()
  }
}
</script>

<style lang='scss' scoped>
.flex {
  display: flex;
}
.tutor2 {
  &:after {
    content: "\f19d";
    font-family: FontAwesome;
    position: absolute;
    font-size: 300px;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -150px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.button-g {
  display: flex;
  margin-bottom: 5px;
}
.btn-square {
  display: inline-block;
  font-size: 10px;
  padding: 7px 5px;
  text-decoration: none;
  background: #fff;
  color: #37474f;
  border: solid 1px #ccc;
  border-radius: 0px;
  margin-right: 1px;
  cursor: pointer;
  width: 60px;
  text-align: center;
}
.active {
  background: #37474f;
  color: #FFF;
  border: solid 1px #37474f;
}
.basic {
  max-width: 100%;
  min-width: 16%;
  flex-basis: 100%;
}
</style>



// WEBPACK FOOTER //
// TutorIndex2.vue?5569164d